/**
 * El contexto de las guías y su hook.
 *
 * Vive aparte del proveedor a propósito: un archivo que exporta un
 * componente y además una función pierde el fast refresh en desarrollo —
 * cada cambio en el proveedor recarga el módulo entero y tira el estado de
 * la aplicación—. Es lo que avisa `react-refresh/only-export-components`.
 */

import { createContext, useContext } from 'react';
import type { TourFlow } from './types';

export interface TourContextValue {
  /** Guías que este operador, con este país, puede hacer. */
  availableFlows: TourFlow[];
  /** La guía de la pantalla en la que está, si existe. */
  flowForCurrentPath: TourFlow | undefined;
  /**
   * Lo que el botón de ayuda ofrece: la guía de esta pantalla y, si no la
   * hay, la primera disponible. **Sin mirar si ya se hizo**: el botón tiene
   * que seguir ahí para repasar, que es cuando de verdad hace falta.
   */
  suggestedFlow: TourFlow | undefined;
  /** Ids de las guías ya terminadas. */
  completed: string[];
  /** True mientras hay una guía en curso. */
  isRunning: boolean;
  startFlow: (flowId: string) => void;
  stopFlow: () => void;
}

export const TourContext = createContext<TourContextValue | null>(null);

export function useTour(): TourContextValue {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used within TourProvider');
  return ctx;
}
